import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TeyaService } from '../../core/services/teya.service';
import { LoaderComponent } from "../../shared-with-client/loader/loader.component";
import { ButtonComponent } from "../../shared-with-client/button/button.component";

@Component({
    selector: 'app-teya-oauth',
    imports: [LoaderComponent],
    templateUrl: './teya-oauth.component.html',
    styleUrl: './teya-oauth.component.scss',
})
export class TeyaOauthComponent {
    private activatedRoute = inject(ActivatedRoute);
    private teyaService = inject(TeyaService);
    private router = inject(Router);

    public loading = signal(false);

    ngOnInit() {
        const code = this.activatedRoute.snapshot.queryParams.code;
        const state = this.activatedRoute.snapshot.queryParams.state;

        if (!code || !state) {
            this.router.navigateByUrl('/dashboard/extensions');
            return;
        }

        this.loading.set(true);

        this.teyaService.completeOAuth(code, state).subscribe({
            next: (result) => {
                const slug = result.storeSlug;

                if (slug) {
                    this.router.navigateByUrl(`/${slug}/dashboard/extensions/teya`);
                } else {
                    this.router.navigateByUrl('/dashboard/extensions/teya');
                }

            },
            error: (error) => {
                this.router.navigateByUrl('/dashboard/extensions');
            },
        });
    }

}
